import {Attendee} from 'Event/attendee'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'

export interface InfusionsoftTag {
  name: string
  id: number
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/infusionsoft/add_tag`)
  return (tag: InfusionsoftTag) => {
    try {
      client.post(url, {
        id: tag.id,
      })
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/infusionsoft/test_tag`)
  return async (tag: InfusionsoftTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      tag,
      attendee_id: attendee.id,
    })
  }
}
